
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import PropTypes from 'prop-types';
import useResponsive from '../../../utils/responsive';

function getSteps() {
    return ['Your Deets', 'Choose Date', 'Confirmation'];
}

const StepConnector = () => {
    return <img src="/assets/images/chevron_right.svg" alt="Step Connector" className='waiting-list-dialog-stepper-step-connector-icon' />;
};

const WaitingListDialogStepper = (props) => {
    const { activeStep } = props;
    const { isMobile } = useResponsive();
    const steps = getSteps();

    const StepIcon = (props) => {
        const { active, icon } = props;
        const activeClass = (active && 'active').toString();

        return (
            <div className={`${activeClass} waiting-list-dialog-stepper-step-icon`}>
                <p className={activeClass}>{icon}</p>
            </div>
        );
    };

    return (
        <Stepper activeStep={activeStep} connector={StepConnector()} className='waiting-list-dialog-stepper' id='waiting-list-dialog-stepper'>
            {steps.map((label, index) => {
                if (isMobile) {
                    return (
                        <Step key={label}>
                            {index === activeStep && (
                                <StepLabel 
                                    slots={{
                                        stepIcon: StepIcon
                                    }}
                                >{label}</StepLabel>
                            )}
                            {index !== activeStep && <StepLabel slots={{ stepIcon: StepIcon }} />}
                        </Step>
                    );
                }
                return (
                    <Step key={label}>
                        <StepLabel slots={{ stepIcon: StepIcon }}>{label}</StepLabel>
                    </Step>
                );
            })}
        </Stepper>
    );
};

export default WaitingListDialogStepper;

WaitingListDialogStepper.propTypes = {
    activeStep: PropTypes.number,
    icon: PropTypes.string,
    active: PropTypes.bool,
};

